<template>
	<div id="app" ref="app">
		<i-header :pdfLink="pdfLinks.full" :pdfLinkShort="pdfLinks.short"/>
		<s-hero/>
		<s-about :pdfLink="pdfLinks.about"/>
		<s-ceo :pdfLink="pdfLinks.ceo"/>
		<s-sustainability :pdfLink="pdfLinks.sustainability"/>
		<s-materials :pdfLink="pdfLinks.materials"/>
		<s-suppliers :pdfLink="pdfLinks.suppliers"/>
		<s-coworkers :pdfLink="pdfLinks.coworkers"/>
		<s-customers :pdfLink="pdfLinks.customers"/>
		<s-download :pdfLink="pdfLinks.full" :pdfLinkShort="pdfLinks.short"/>
		<i-footer/>
	</div>
</template>
<script>
	// includes
	import IHeader from './includes/Header.vue';
	import IFooter from './includes/Footer.vue';
	// sections
	import SHero 			from './sections/Hero.vue';
	import SAbout 			from './sections/About.vue';
	import SCeo 			from './sections/Ceo.vue';
	import SSustainability 	from './sections/Sustainability.vue';
	import SMaterials 		from './sections/Materials.vue';
	import SSuppliers 		from './sections/Suppliers.vue';
	import SCoworkers 		from './sections/Coworkers.vue';
	import SCustomers 		from './sections/Customers.vue';
	import SDownload 		from './sections/Download.vue';
	// pdfs
	import pdfFull 		from './assets/pdf/full.pdf';
	import pdfShort 	from './assets/pdf/short.pdf';
	import pdfAbout 	from './assets/pdf/about.pdf';
	import pdfCeo 		from './assets/pdf/ceo.pdf';
	import pdfMaterials from './assets/pdf/materials.pdf';
	import pdfSuppliers from './assets/pdf/suppliers.pdf';
	import pdfCoworkers from './assets/pdf/coworkers.pdf';
	import pdfCustomers from './assets/pdf/customers.pdf';
	export default {
		name: 'App',
		components: {
			IHeader,
			IFooter,
			SHero,
			SAbout,
			SCeo,
			SSustainability,
			SMaterials,
			SSuppliers,
			SCoworkers,
			SCustomers,
			SDownload
		},
		data() {
			return {
				pdfLinks: {
					full: {
						org: pdfFull,
						fallback: pdfFull,
						page: 1
					},
					short: {
						org: pdfShort,
						fallback: pdfShort,
						page: 1
					},
					about: {
						org: pdfFull,
						fallback: pdfAbout,
						page: 5
					},
					ceo: {
						org: pdfFull,
						fallback: pdfCeo,
						page: 4
					},
					materials: {
						org: pdfFull,
						fallback: pdfMaterials,
						page: 21
					},
					suppliers: {
						org: pdfFull,
						fallback: pdfSuppliers,
						page: 25
					},
					coworkers: {
						org: pdfFull,
						fallback: pdfCoworkers,
						page: 29
					},
					customers: {
						org: pdfFull,
						fallback: pdfCustomers,
						page: 47
					}
				}
			}
		}
	}
</script>
<style lang="scss">
	@import "~bootstrap/scss/functions";
	@import "~bootstrap/scss/variables";
	/* custom variables */
	@import "./assets/css/custom-variables";
	/* core */
	@import "~bootstrap/scss/mixins";
	@import "~bootstrap/scss/print";
	@import "~bootstrap/scss/reboot";
	@import "~bootstrap/scss/grid";
	@import "~bootstrap/scss/utilities";
	@import "~bootstrap/scss/type";
	/* components */
	@import "~bootstrap/scss/nav";
	@import "~bootstrap/scss/navbar";
	@import "~bootstrap/scss/buttons";
	@import "~bootstrap/scss/transitions";
	@import "~bootstrap/scss/images";
	@import "~bootstrap/scss/modal";
	@import "~bootstrap/scss/close";
	@import "~bootstrap/scss/alert";
	/* add components over this line for use
	@import "~bootstrap/scss/forms";
	@import "~bootstrap/scss/custom-forms";
	@import "~bootstrap/scss/dropdown";
	@import "~bootstrap/scss/button-group";
	@import "~bootstrap/scss/input-group";
	@import "~bootstrap/scss/progress";
	@import "~bootstrap/scss/list-group";
	@import "~bootstrap/scss/card";
	@import "~bootstrap/scss/breadcrumb";
	@import "~bootstrap/scss/tables";
	@import "~bootstrap/scss/badge";
	@import "~bootstrap/scss/tooltip";
	@import "~bootstrap/scss/code";
	@import "~bootstrap/scss/pagination";
	@import "~bootstrap/scss/media";
	@import "~bootstrap/scss/popover";
	@import "~bootstrap/scss/jumbotron";
	@import "~bootstrap/scss/carousel";*/
	/* custom css */
	@import "./assets/css/app";
</style>
